import React from 'react';
import { Link } from 'react-router-dom';
import { whatsappUrl } from './WhatsAppButton';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="content footer-grid">
        <div className="footer-brand-block">
          <img src="/assets/images/zyvora-cow-logo.png" alt="Zyvora Life Sciences 9 logo mark" className="footer-logo" />
          <div>
            <h2>Zyvora Life Sciences&nbsp;9</h2>
            <p>Premium cattle feed supplements for livestock health, dairy performance, digestion, immunity, and distributor-ready supply.</p>
            <Link to="/contact" className="footer-cta">Become a Distributor</Link>
          </div>
        </div>
        <nav aria-label="Footer navigation">
          <h3>Quick Links</h3>
          <Link to="/products">Products</Link>
          <Link to="/catalogues">Catalogue</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Distributor Inquiry</Link>
        </nav>
        <div className="footer-contact">
          <h3>Business Details</h3>
          <p><strong>GSTIN:</strong> 09AXTPS5184M1Z9</p>
          <p><strong>Registered Address:</strong><br />A108, Judge’s Cultural &amp; Welfare Organisation, Greater Noida, Delhi NCR, Pin: 201310</p>
          <p><strong>WhatsApp:</strong> +91 9868510836, +91 7005032815<br /><strong>Email:</strong> sales@zyvoralifesciences.com</p>
          <a href={whatsappUrl} target="_blank" rel="noreferrer" className="text-link">WhatsApp Inquiry →</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
